import type { Container } from 'pixi.js';
import { onLayoutPopulated } from '../populate';
import { applyLayoutState } from '../populateLayouts/applyLayoutState';
import type { Layout } from '../populateLayouts/types/Layout';

export function layoutLocaSkinSPL(getLanguage: () => string): void {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    onLayoutPopulated.connect((layout: { locaSkin_SPL?: Container[], statesName?: string[] }) => {
      if (!layout.locaSkin_SPL) return;
      applyLayoutState(layout as Layout, getLanguage());
    });
}
